import type {WordId} from '$lib/classes/data/_primitives';

export function wordIdToFilename(wordId: WordId) {
    switch (wordId) {
        case 'pron/Ihr':
            wordId = 'pron/ihr'
            break;
        case 'pron/Sie':
            wordId = 'pron/sie'
            break;
        case 'pron/Ihnen':
            wordId = 'pron/ihnen'
            break;
    }
    wordId = wordId.replaceAll('/', '_')
    wordId = wordId.replaceAll('ä', 'ae')
    wordId = wordId.replaceAll('ö', 'oe')
    wordId = wordId.replaceAll('ü', 'ue')
    wordId = wordId.replaceAll('Ä', 'Ae')
    wordId = wordId.replaceAll('Ö', 'Oe')
    wordId = wordId.replaceAll('Ü', 'Ue')
    wordId = wordId.replaceAll('ß', 'ss')
    return wordId
}